import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './config/i18n/config';
import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(process.env.MUI_PRO_LICENSE || '');

const root = createRoot(document.getElementById('root') as Element);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
